export default __webpack_public_path__ + "static/media/hht2_ep9_speaking_02.caf48a16.png";